export const handleError = (error, defaultMessage = 'An error occurred') => {
  if (typeof error === 'string') return error;

  const res = error?.response;
  if (res) {
    // Prefer `error` field returned by our PHP API, then `message`
    const apiMessage = res.data?.error || res.data?.message;

    // Map the self-delete server message to the friendly client text requested
    if (res.status === 403 && apiMessage && /delete\s+yourself/i.test(apiMessage)) {
      return 'error: you cannot delete your self';
    }

    return apiMessage || error?.message || defaultMessage;
  }

  return error?.message || defaultMessage;
};

export const getErrorMessage = (error) => {
  if (typeof error === 'string') return error;

  const res = error?.response;
  if (res) {
    const apiMessage = res.data?.error || res.data?.message;
    if (res.status === 403 && apiMessage && /delete\s+yourself/i.test(apiMessage)) {
      return 'error: you cannot delete your self';
    }
    return apiMessage || error?.message || 'An error occurred';
  }

  return error?.message || 'An error occurred';
};